import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Purchases/MaterialIssue/forms";
import headers from "../../../../Data/Forms/Purchases/MaterialIssue/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import { Checkbox, Input } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { get_inventories_by_product } from "../../../../Controllers/Inventory/Batch";
import {
  create_material_issue,
  get_material_issue,
  update_material_issue,
} from "../../../../Controllers/Purchases/MaterialIssue";
import MaterialIssuetable from "../../../../Data/Forms/Purchases/MaterialIssue/table";
import { get_material_request } from "../../../../Controllers/Purchases/MaterialRequests";

const InventoryMaterialIssueForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const requestIdFromQuery = queryParams.get("request");

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);
  const [requestData, setRequestData] = useState(null);

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      requested_quantity: "",
      issued_quantity: "",
      invoice: "",
      invoice_price: "",
      invoice_options: null,
      delivered: "",
      tax: null,
      free: "",
      barcode: "",
      price_per_unit: "",
      sale_price: "",
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
      inventory_source: null,
      is_sub_row: false,
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    payments: {
      Cash: "",
      "Debit card": "",
      "Credit card": "",
      "Bank transfer": "",
      "Online payment": "",
      Cheque: "",
    },
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(`description${i}`).textContent =
              `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (
            !v?.issued_quantity ||
            parseFloat(v?.issued_quantity) <= 0
          ) {
            document.getElementById(`issued_quantity${i}`).textContent =
              `Issued quantity is required and must be greater than 0`;
            focus.current[`issued_quantity${i}`].current.focus();
          } else if (
            !v?.is_sub_row &&
            parseFloat(v?.issued_quantity) > parseFloat(v?.requested_quantity)
          ) {
            document.getElementById(`issued_quantity${i}`).textContent =
              `Issued quantity cannot exceed requested quantity`;
            focus.current[`issued_quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`issued_quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};
    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      document.getElementById(`delivery_date`).textContent =
        `Issue Date is required`;
      focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(`payment_types`).textContent =
        `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      if (totals?.payment_types?.length > 0) {
        totals?.payment_types?.map((v, i) => {
          if (count_payment_types == i) {
            if (!totals?.payments?.[v]?.amount) {
              document.getElementById(`${v}`).textContent = `${v} is required`;
              focus.current[`${v}`].current.focus();
            } else {
              document.getElementById(`${v}`).textContent = ``;
              count_payment_types++;
            }
          }
        });

        if (count_payment_types == total_payment_types) {
          params = {
            status: true,
            data: {
              ...tabledata,
              id: id ? id : "",
              subtotal: totals?.subtotal,
              taxamount: totals?.taxamount,
              discount: totals?.discount,
              delivery: totals?.delivery,
              delivery_status: totals?.delivery_status,
              delivery_date: totals?.delivery_date,
              payment_status: totals?.payment_status,
              payment_types: totals?.payment_types,
              payments: totals?.payments,
              total: totals?.total,
            },
          };
          return params;
        } else {
          params = {
            status: false,
            data: null,
          };
          return params;
        }
      } else {
        params = {
          status: true,
          data: {
            ...tabledata,
            id: id ? id : "",
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
          },
        };
        return params;
      }
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        setButtonLoader(true);

        const preparedDetails = tabledetailsvalidation?.data?.details?.map(
          (detail) => ({
            ...detail,
            inventory_source: detail.inventory_source || null,
          }),
        );

        const payload = {
          ...tabledetailsvalidation?.data,
          details: preparedDetails,
        };

        const issue = id
          ? await update_material_issue({
              ...payload,
              issue: id,
            })
          : await create_material_issue({
              ...payload,
              issue: id,
            });

        if (issue?.status) {
          navigate(-1);
          toast?.success(issue?.message);
          setButtonLoader(false);
        } else {
          setButtonLoader(false);
          if (issue?.status_code == 403) {
            window.location.href = "/unauthorized";
          } else {
            toast?.error(issue?.message);
          }
        }
      }
    }
  };

  const handleData = (issue) => {
    let request = issue?.request?._id ? issue?.request?._id : null;
    let number = issue?.number ? issue?.number : "";
    let date = issue?.date ? issue?.date : "";
    let issue_date = issue?.issue_date ? issue?.issue_date : "";
    let status = issue?.status ? issue?.status : 0;

    let requestNumber = issue?.request?.number
      ? issue?.request?.number.toString().startsWith("REQ-")
        ? issue?.request?.number
        : `REQ-${issue?.request?.number}`
      : "";

    let request_option = issue?.request?._id
      ? [
          {
            value: issue?.request?._id,
            label: `#${requestNumber}`,
          },
        ]
      : null;

    values[0].options[0].form.value = request;
    values[0].options[0].form.options = request_option;
    values[0].options[1].form.value = number;
    values[0].options[2].form.value = date;
    values[0].options[3].form.value = issue_date;
    values[0].options[4].form.value = status;

    let data = [];

    issue?.details?.map((value, index) => {
      let stock = value?.inventory?.stock;

      if (value?.unit != value?.inventory?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        description: value?.inventory?._id,
        batch: value?.inventory?.number,
        expiry_date: value?.inventory?.expiry_date,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        requested_quantity: value?.requested_quantity,
        issued_quantity: value?.issued_quantity,
        previous_issued: value?.previous_issued || 0,
        free: value?.free,
        tax: value?.tax?.rate ? value?.tax?.rate : 0,
        tax_details: value?.tax ? value?.tax : null,
        barcode: value?.barcode,
        purchase_price: value?.purchase_price,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
        inventory_source: value?.inventory_source || null,
        is_sub_row: value?.is_sub_row || false,
      });
    });

    let payment_types = [];
    let payments = {};
    issue?.payments?.map((v, i) => {
      payment_types?.push(v?.name);
      payments[v?.name] = { id: v?._id, amount: v?.amount };
    });

    totals.subtotal = issue?.subtotal;
    totals.taxamount = issue?.taxamount;
    totals.discount = issue?.discount;
    totals.delivery = issue?.delivery;
    totals.delivery_status = issue?.delivery_status;
    totals.delivery_date = issue?.delivery_date;
    totals.payment_status = issue?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = issue?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);
      const data = {
        id: id,
      };
      const issue = await get_material_issue(data);
      if (issue?.status) {
        handleData(issue?.data);
      } else {
        toast?.error(issue?.message);
      }
    } else if (requestIdFromQuery) {
      setLoader(true);
      const res = await get_material_request({ id: requestIdFromQuery });
      if (res?.status) {
        setRequestData(res?.data);
        await handleMaterialRequestData(res?.data);
        setLoader(false);
      } else {
        toast?.error(res?.message || "Failed to fetch material request");
        setLoader(false);
      }
    } else {
      values[0].options[2].form.value = new Date();
      values[0].options[3].form.value = new Date();

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;
      totals.payment_types = ["Cash"];

      setValues([...values]);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  const handleMaterialRequestData = async (request) => {
    const requestNumber = request?.number?.toString().startsWith("REQ-")
      ? request?.number
      : `REQ-${request?.number}`;

    values[0].options[0].form.value = request?._id;
    values[0].options[0].form.options = [
      {
        value: request?._id,
        label: `#${requestNumber}`,
      },
    ];

    values[0].options[2].form.value = new Date();
    values[0].options[3].form.value = new Date();

    const newDetails = [];

    for (const detail of request?.details || []) {
      const productName = detail?.description?.name || detail?.name;
      const productId = detail?.description?._id;
      const requestedQuantity = detail?.quantity_requested || 0;
      const alreadyIssued = detail?.issued || 0;
      const remainingQuantity = requestedQuantity - alreadyIssued;

      if (remainingQuantity <= 0) continue;

      const inventoryResponse = await get_inventories_by_product({
        product_id: productId,
      });

      let totalIssued = 0;
      let detailRows = [];
      let selectedInventories = [];

      if (inventoryResponse?.status && inventoryResponse?.data?.length > 0) {
        const inventories = inventoryResponse?.data;

        const sortedInventories = inventories
          .filter((inv) => inv?.stock > 0)
          .sort((a, b) => {
            if (a?.stock === 0 && b?.stock > 0) return 1;
            if (a?.stock > 0 && b?.stock === 0) return -1;
            if (a?.expiry_date && b?.expiry_date) {
              return new Date(a.expiry_date) - new Date(b.expiry_date);
            }
            return 0;
          });

        let quantityToAllocate = remainingQuantity;

        for (const inventory of sortedInventories) {
          if (quantityToAllocate <= 0) break;

          const availableStock = inventory?.stock || 0;
          const allocatedFromThis = Math.min(
            quantityToAllocate,
            availableStock,
          );

          if (allocatedFromThis > 0) {
            selectedInventories.push({
              inventory: inventory,
              allocatedQuantity: allocatedFromThis,
            });
            quantityToAllocate -= allocatedFromThis;
          }
        }

        if (selectedInventories.length > 0) {
          let isFirstRow = true;

          for (const selected of selectedInventories) {
            const inventory = selected.inventory;
            const allocatedQty = selected.allocatedQuantity;

            let unitName = inventory?.product?.unit?.name || "";
            if (inventory?.inventory_unit_details?.length > 0) {
              const mainUnit = inventory.inventory_unit_details.find(
                (u) => u.conversion === 1 || u.name === unitName,
              );
              if (mainUnit) unitName = mainUnit.name;
            }

            const rowData = {
              id: "",
              description: inventory?._id,
              name: productName,
              unit: inventory?._id,
              unit_name: unitName,
              unit_details_options: inventory?.inventory_unit_details || [],
              conversion: 1,
              quantity: allocatedQty,
              requested_quantity: isFirstRow ? remainingQuantity : 0, 
              issued_quantity: allocatedQty,
              invoice: "",
              invoice_price: "",
              invoice_options: null,
              delivered: allocatedQty,
              tax: inventory?.tax || null,
              tax_details: inventory?.tax_details || null,
              free: 0,
              barcode: inventory?.barcode || "",
              price_per_unit:
                inventory?.price_per_unit || inventory?.purchase_price || 0,
              sale_price: inventory?.sale_price || 0,
              purchase_price: inventory?.purchase_price || 0,
              expiry_date: inventory?.expiry_date || "",
              tax_amount: "0.000",
              total: 0,
              stock: inventory?.stock || 0,
              batch: inventory?.number || "",
              inventory_source: inventory?._id,
              is_sub_row: !isFirstRow,
            };

            const price = allocatedQty * (rowData.price_per_unit || 0);
            const taxRate = rowData.tax?.rate || rowData.tax || 0;
            const taxAmount = price * (taxRate / 100);
            rowData.tax_amount = taxAmount;
            rowData.total = price + taxAmount;

            detailRows.push(rowData);
            isFirstRow = false;
          }
        } else {
          const rowData = {
            id: "",
            description: productId,
            name: productName,
            unit: productId,
            unit_name: "",
            unit_details_options: [],
            conversion: 1,
            quantity: 0,
            requested_quantity: remainingQuantity,
            issued_quantity: 0,
            invoice: "",
            invoice_price: "",
            invoice_options: null,
            delivered: 0,
            tax: null,
            tax_details: null,
            free: 0,
            barcode: "",
            price_per_unit: 0,
            sale_price: 0,
            purchase_price: 0,
            expiry_date: "",
            tax_amount: "0.000",
            total: 0,
            stock: 0,
            batch: "",
            inventory_source: null,
            is_sub_row: false,
          };
          detailRows.push(rowData);
        }
      } else {
        const rowData = {
          id: "",
          description: productId,
          name: productName,
          unit: productId,
          unit_name: "",
          unit_details_options: [],
          conversion: 1,
          quantity: 0,
          requested_quantity: remainingQuantity,
          issued_quantity: 0,
          invoice: "",
          invoice_price: "",
          invoice_options: null,
          delivered: 0,
          tax: null,
          tax_details: null,
          free: 0,
          barcode: "",
          price_per_unit: 0,
          sale_price: 0,
          purchase_price: 0,
          expiry_date: "",
          tax_amount: "0.000",
          total: 0,
          stock: 0,
          batch: "",
          inventory_source: null,
          is_sub_row: false,
        };
        detailRows.push(rowData);
      }

      newDetails.push(...detailRows);
    }

    if (newDetails.length > 0) {
      setDetails(newDetails);
      setTimeout(() => {
        recalculateTotals(newDetails);
      }, 100);
    }

    setValues([...values]);
    setTotals({ ...totals });
  };

  const recalculateTotals = (detailsData) => {
    const subtotal =
      detailsData?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total || 0),
        0,
      ) -
      detailsData?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount || 0),
        0,
      );

    const taxamount = detailsData?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.tax_amount || 0),
      0,
    );

    const grandtotal = detailsData?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.total || 0),
      0,
    );

    setTotals((prev) => ({
      ...prev,
      subtotal: subtotal || 0,
      taxamount: taxamount || 0,
      total: grandtotal || 0,
    }));
  };

  const handleMaterialRequestNumberChange = async (number) => {
    if (!number) return;

    const res = await get_material_request({ id: number });
    if (res?.status) {
      setRequestData(res?.data);
      await handleMaterialRequestData(res?.data);
    } else {
      toast.error(res.message || "Purchase not found");
    }
  };

  const selectHandlers = {
    number: handleMaterialRequestNumberChange,
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          selectHandlers={selectHandlers}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <MaterialIssuetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
                requestData={requestData}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryMaterialIssueForm;
